import React from "react";

import CompanyHeroSection from "../Components/home/CompanyHeroSection";
import ProductPortfolioSection from "../Components/home/ProductPortfolioSection";
import CompanyPrinciplesSection from "../Components/home/CompanyPrinciplesSection";
import CompanyScenesSection from "../Components/home/CompanyScenesSection";
import CompanyClosingSection from "../Components/home/CompanyClosingSection";
import Reveal from "../Components/home/Reveal";

export default function Home() {
  return (
    <main className="home-paper overflow-hidden text-slate-900">
      <HomeScrollProgress />
      <CompanyHeroSection />
      <Reveal replay variant="rise"><ProductPortfolioSection /></Reveal>
      <Reveal replay variant="left"><CompanyPrinciplesSection /></Reveal>
      <Reveal replay variant="right"><CompanyScenesSection /></Reveal>
      <Reveal replay variant="zoom"><CompanyClosingSection /></Reveal>
    </main>
  );
}

function HomeScrollProgress() {
  const [progress, setProgress] = React.useState(0);

  React.useEffect(() => {
    function updateProgress() {
      const scrollableHeight = document.documentElement.scrollHeight - window.innerHeight;
      setProgress(scrollableHeight > 0 ? Math.min(Math.max(window.scrollY / scrollableHeight, 0), 1) : 0);
    }

    updateProgress();
    window.addEventListener("scroll", updateProgress, { passive: true });
    window.addEventListener("resize", updateProgress);
    return () => {
      window.removeEventListener("scroll", updateProgress);
      window.removeEventListener("resize", updateProgress);
    };
  }, []);

  return (
    <div data-home-scroll-progress className="pointer-events-none fixed inset-x-0 top-[68px] z-40 h-[3px] bg-transparent md:top-[74px]" aria-hidden="true">
      <span className="block h-full origin-left bg-gradient-to-r from-brand-300 via-brand-500 to-brand-700 shadow-[0_0_12px_rgba(14,181,126,.4)] transition-transform duration-150 ease-out motion-reduce:transition-none" style={{ transform: `scaleX(${progress})` }} />
    </div>
  );
}
